// 通常需要支持小程序的都需要确保 WeixinJSBridgeReady
// 通常有页面跳转的都需要支持小程序
import '@zhenguo/jssdk/bootstrap'
import Vue from 'vue'
import installCommonPlugins from './common-plugin'
import installCommonComponents from './common-components'
import { lxMV, lxPV } from '@zhenguo/jssdk/lx'
import addAgentClass from '@zhenguo/jssdk/add-agent-class'
import mpOauth, { I_MP_ACCOUNT } from '@zhenguo/jssdk/mp-oauth'
import Agent, { checkAgent } from '@zhenguo/jssdk/agent'
import getURLSearchParam from '@zhenguo/jssdk/base/url'
import { getAppEnv } from '@zhenguo/jssdk/base/env'
import { APP_ENV } from '@zhenguo/jssdk/consts'

const notProd = getAppEnv() !== APP_ENV.production
Vue.config.productionTip = notProd
Vue.config.performance = notProd

interface PAGE_OPTIONS {
  App: typeof Vue
  router?: any
  noPV?: boolean
  installPagePlugins: (x: typeof Vue) => void
  mpact: I_MP_ACCOUNT
}
async function pageReady({ App, router, noPV, installPagePlugins, mpact }: PAGE_OPTIONS) {
  const mpoauth = mpOauth(mpact)
  if (!noPV) {
    lxPV()
  }
  const checkResult = checkAgent(Agent)
  if (checkResult.message) {
    checkResult.status === -3 && lxMV('b_airbnb_6vcb9m8l_mv')
    checkResult.status === -4 && lxMV('b_airbnb_d4ahftq9_mv')
    lxMV('b_airbnb_hxgpq65i_mv', {
      custom: {
        title: checkResult.message,
      },
    })
    window.$toasted.show(checkResult.message, {
      duration: 5000,
    })
  }
  addAgentClass(Agent)
  const app = new Vue({
    router,
    px2rem: (a: number) => a / 37.5,
    mounted: () => {
      if (Agent.anyminiprogram && Number(getURLSearchParam('login')) === 1 && getURLSearchParam('token')) {
        window.$bus.$emit('login-success')
      }
    },
    render: (h) => {
      return h(App)
    },
  })
  installCommonPlugins(Vue)
  installPagePlugins && installPagePlugins(Vue)
  installCommonComponents(Vue)
  Vue.prototype.$mpoauth = window.$mpoauth = mpoauth
  app.$mount('#app')
  return app
}

export default function ensureMpReady(options: PAGE_OPTIONS) {
  if (Agent.weixin) {
    // 不等 WeixinJSBridge 会有一些功能无法正常使用
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      // 手机端需要等桥ready
      document.addEventListener('WeixinJSBridgeReady', () => pageReady(options), false)
    } else {
      pageReady(options)
    }
    return
  }
  pageReady(options)
}